import React from 'react';
import { useSelector } from 'react-redux';
import { AppContent, baseUnit, ErrorBoundary, FeedGroupList, FeedsNavbar, PrimarySectionTitle } from 'mm-ui-components';
import { Store } from 'redux';
import { css, StyleSheet } from 'aphrodite/no-important';
import { Theme } from '../../components/connectedComponents/Theme';
import { MetaTags } from '../../components/connectedComponents/MetaTags';
import { HeadScripts } from '../../components/connectedComponents/HeadScripts';
import { Page } from '../Page';
import {
  getIndexPage,
} from '../../store/template/indexPage/indexPagePaphos/indexPagePaphos.selectors';
import { ErrorReporter } from '../../errorReporting/errorReporter.type';
import { AppActions, AppState } from '../../store/initialStateRegistration';
import { useMeasureHydrateTime } from '../useMeasureHydrateTime';
import { NavigationLayout } from '../../components/connectedComponents/NavigationLayout';

interface IndexPageProps {
  store: Store<AppState, AppActions>;
  errorProvider: ErrorReporter;
}

export const IndexPagePaphosComponent: React.FunctionComponent<IndexPageProps> = ({ store, errorProvider }) => {
  useMeasureHydrateTime();
  return (
    <Page store={store} errorProvider={errorProvider}>
      <ErrorBoundary>
        <IndexPagePaphosContentConnected />
      </ErrorBoundary>
    </Page>
  );
};

const createStyles = () => StyleSheet.create({
  pageContainer: {
    padding: baseUnit,
    paddingBottom: baseUnit * 6,
    maxWidth: 1100,
    margin: '0 auto',
  },
  navbarContainer: {
    marginTop: baseUnit * 1.5,
    display: 'flex',
    justifyContent: 'center',
  },
});

export const IndexPagePaphosContentConnected: React.FunctionComponent = () => {
  const { title, feedGroups, currentGroup, feedGroupAll, moreButtonLabel, metadataTitle, metadataDescription, metadataImage, hreflangData } = useSelector(getIndexPage);
  const style = createStyles();

  return (
    <React.Fragment>
      <MetaTags title={metadataTitle} description={metadataDescription} pageImage={metadataImage} alternateUrls={hreflangData || []} />
      <HeadScripts />
      <Theme>
        <AppContent>
          <NavigationLayout mainWrapperConfigThemeKey="mainArticleContent">
            <div className={css(style.pageContainer)}>
              <PrimarySectionTitle>{title}</PrimarySectionTitle>
              <hr />
              <div className={css(style.navbarContainer)}>
                <FeedsNavbar feedGroups={feedGroups} currentGroup={currentGroup} feedGroupAll={feedGroupAll} />
              </div>
              <FeedGroupList feedGroups={feedGroups} currentGroup={currentGroup} moreButtonLabel={moreButtonLabel} />
            </div>
          </NavigationLayout>
        </AppContent>
      </Theme>
    </React.Fragment>
  );
};
